import { Expression } from '@skinsoft/types'
import { dbCacheDown } from '../dexie/cache-down'
import { STATS_KEYS } from '../dexie/stats-keys'
import { OfflineDataFetcher } from '@skinsoft/offline'

export class ExpressionOfflineDataFetcher extends OfflineDataFetcher<Expression>{

    constructor() {
        super(dbCacheDown.expression, STATS_KEYS.expression)
    }

    /*public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.expression) {
            return entity.expression.id === id;
        }
        return false;
    }

}